var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.599 2.93021C17.9959 2.93021 18.3177 3.252 18.3177 3.64896V7.71482C18.3177 8.11177 17.9959 8.43357 17.599 8.43357H13.5331C13.1361 8.43357 12.8143 8.11177 12.8143 7.71482C12.8143 7.31787 13.1361 6.99607 13.5331 6.99607H15.7951C13.0683 4.84645 9.10309 5.02957 6.58724 7.54541C3.87391 10.2587 3.87391 14.6579 6.58724 17.3712C9.30057 20.0846 13.6998 20.0846 16.4131 17.3712C18.2309 15.5534 18.8318 12.9785 18.2122 10.6584C18.1098 10.2749 18.3377 9.88101 18.7212 9.77859C19.1047 9.67617 19.4986 9.90405 19.6011 10.2876C20.3476 13.083 19.6249 16.1924 17.4295 18.3877C14.1548 21.6624 8.84549 21.6624 5.57078 18.3877C2.29607 15.113 2.29607 9.80365 5.57078 6.52894C8.66813 3.43159 13.5857 3.26384 16.8802 6.02568V3.64896C16.8802 3.252 17.202 2.93021 17.599 2.93021Z",
    fill: "#3162AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartIcon);
export default __webpack_public_path__ + "static/media/RestartIcon.f0f824ea7f176e49318fae872b68f109.svg";
export { ForwardRef as ReactComponent };